import(/* webpackMode: "eager" */ "/Users/juancartagena/foundry/neotral/apps/web-app/src/app/error.tsx");
